import moment from 'moment';
import {
  CRITERIA,
  YES_NO_OPTIONS_VALUES,
  PROPERTY_TYPE_OPTIONS_VALUES,
  PROPERTY_TYPE_OPTIONS,
  REQUEST_OPTIONS_VALUES,
  REQUEST_OPTIONS,
  ALL_PART_NONE_OPTIONS_VALUES,
  ALL_PART_NONE_OPTIONS,
  DELIVERY_DAY_OPTIONS_VALUES,
  DELIVERY_DAY_OPTIONS,
  YES_NO_OPTIONS,
  EXCEPTION_TYPES,
  PICKUP_KIND_OPTIONS,
} from './constants';
import { getStopTypeOptions, getStopTypeDefault } from './model';

export const CRITERIA_CONFIGS = {
  [CRITERIA.CADS]: {
    default: ALL_PART_NONE_OPTIONS_VALUES.ALL,
    options: ALL_PART_NONE_OPTIONS,
    type: 'select',
  },
  [CRITERIA.DELIVERY_DAY]: {
    default: DELIVERY_DAY_OPTIONS_VALUES.SATURDAY,
    options: DELIVERY_DAY_OPTIONS,
    type: 'select',
  },
  [CRITERIA.ETA]: {
    operators: true,
    default: (route) => {
      const stops = route?.stop;

      let defaultValue = moment().hour(0).minute(0).toISOString();

      if (stops?.length > 0) {
        const stopWithLowestSequence = stops.reduce((previous, next) => {
          if (next.sequenceNumber < previous.sequenceNumber) {
            return next;
          }

          return previous;
        });

        if (typeof stopWithLowestSequence?.eta === 'string') {
          const etaParts = stopWithLowestSequence.eta.match(/\d{2}/g);
          defaultValue = moment()
            .hour(etaParts[0])
            .minute(etaParts[1])
            .toISOString();
        }
      }

      return defaultValue;
    },
    type: 'time',
  },
  [CRITERIA.EXCEPTION]: {
    type: 'select',
    options: (route) => {
      const options = new Set([
        {
          value: ALL_PART_NONE_OPTIONS_VALUES.ALL,
          label: 'All',
        },
        {
          value: ALL_PART_NONE_OPTIONS_VALUES.NONE,
          label: 'None',
        },
      ]);

      if (!route?.totalExceptions) {
        return [...options];
      }

      const stops = route?.stop || [];

      stops.forEach(({ exception }) => {
        if (exception && EXCEPTION_TYPES[exception]) {
          options.add(EXCEPTION_TYPES[exception]);
        }
      });

      return [...options];
    },
    default: ALL_PART_NONE_OPTIONS_VALUES.ALL,
  },
  [CRITERIA.HUB_LAST_SCANNED_IN]: {
    type: 'select',
    options: (route) => {
      let hubLastSeenArray = new Set();
      const stops = route?.stop || [];

      stops.forEach(({ parcel }) => {
        if (!parcel) {
          return;
        }

        parcel.forEach(({ hubLastSeen }) => {
          if (hubLastSeen) {
            hubLastSeenArray.add(hubLastSeen);
          }
        });
      });
      hubLastSeenArray = [...hubLastSeenArray].map((value) => ({
        label: value,
        value,
      }));

      return hubLastSeenArray;
    },
    default: (route) => {
      let hubLastSeenArray = [];
      const stops = route?.stop || [];

      stops.forEach(({ parcel }) => {
        if (!parcel) {
          return;
        }

        parcel.forEach(({ hubLastSeen }) => {
          hubLastSeenArray.push(hubLastSeen);
        });
      });
      hubLastSeenArray = [...new Set(hubLastSeenArray)];

      return hubLastSeenArray[0];
    },
  },
  [CRITERIA.HUB_SCAN_DATE_TIME]: {
    type: 'datetime',
    default: Date.now(),
    operators: true,
  },
  [CRITERIA.LOADED]: {
    type: 'select',
    options: ALL_PART_NONE_OPTIONS,
    default: ALL_PART_NONE_OPTIONS_VALUES.ALL,
  },
  [CRITERIA.OPPORTUNITY_TIME]: {
    operators: true,
    type: 'time',
    default: moment().hour(1).minute(0).toISOString(),
  },
  [CRITERIA.PARCEL_AGE]: {
    operators: true,
    type: 'number',
    default: null,
  },
  [CRITERIA.PARCELS_NO_OF]: {
    operators: true,
    type: 'number',
    default: null,
  },
  [CRITERIA.PERISHABLE]: {
    type: 'select',
    default: YES_NO_OPTIONS_VALUES.YES,
    options: YES_NO_OPTIONS,
  },
  [CRITERIA.POSTCODE]: {
    type: 'string',
    default: '',
  },
  [CRITERIA.PRECISE]: {
    type: 'select',
    default: YES_NO_OPTIONS_VALUES.YES,
    options: YES_NO_OPTIONS,
  },
  [CRITERIA.PREMIUMS]: {
    type: 'select',
    default: YES_NO_OPTIONS_VALUES.YES,
    options: YES_NO_OPTIONS,
  },
  [CRITERIA.PRIORITY]: {
    type: 'number',
    operators: true,
    default: null,
  },
  [CRITERIA.PROPERTY_TYPE]: {
    type: 'select',
    default: PROPERTY_TYPE_OPTIONS_VALUES.B2B,
    options: PROPERTY_TYPE_OPTIONS,
  },
  [CRITERIA.REQUEST]: {
    type: 'select',
    default: REQUEST_OPTIONS_VALUES.OPEN,
    options: REQUEST_OPTIONS,
  },
  [CRITERIA.SMALLS]: {
    type: 'select',
    default: YES_NO_OPTIONS_VALUES.YES,
    options: YES_NO_OPTIONS,
  },
  [CRITERIA.STOP_TIME]: {
    type: 'time',
    operators: true,
    default: moment().hour(2).minute(0).toISOString(),
  },
  [CRITERIA.STOP_TYPE]: {
    type: 'select',
    options: getStopTypeOptions,
    default: getStopTypeDefault,
  },
  [CRITERIA.MANIFEST_LOCATION]: {
    type: 'string',
    default: '',
  },
  [CRITERIA.PICKUP_KIND]: {
    type: 'select',
    options: PICKUP_KIND_OPTIONS,
    default: PICKUP_KIND_OPTIONS[0].value,
  },
};
